import React from 'react';
import { useBrand } from '@edreamsodigeo/frontend-core';
import {
  BrandEdIcon,
  BrandGoIcon,
  BrandOpIcon,
  BrandTlIcon,
} from '@edreamsodigeo/prisma-design-system';
import { PrimeEDIcon } from '../PrimeEDIcon';

const brandComponents = {
  ED: BrandEdIcon,
  GO: BrandGoIcon,
  OP: BrandOpIcon,
  TL: BrandTlIcon,
};

const BrandIcon = (args) => {
  const brand = useBrand();
  const Icon = brandComponents[brand];
  if (args.newColor && brand === 'ED') {
    return <PrimeEDIcon />;
  } else {
    return <Icon data-testid="brand-icon" {...args} />;
  }
};

export default BrandIcon;
